import { Link, Navigate, useParams } from 'react-router-dom';
import { Button, Flex, Text, VStack } from '@chakra-ui/react';
import { useProjectQuery } from '../../generated/graphql';
import { HelivanLoading } from '../HelivanLoading';
import { ProjectView } from './ProjectView';
import { useErrorHandler } from '../../hooks/useErrorHandler';
import { useEffect } from 'react';

export const ProjectViewRoute = () => {
  const { projectId } = useParams();
  const { handleError } = useErrorHandler();
  const { data, loading, error } = useProjectQuery({
    variables: { id: projectId || '' },
    errorPolicy: 'all', // This allows the query to return partial data along with errors
  });

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error, handleError]);

  if (loading) {
    return <HelivanLoading />;
  }

  // If we have data, show it even if there was an error (partial data)
  if (data?.project) {
    return <ProjectView project={data.project} />;
  }

  // No project AND an error: don't bounce to /projects (that redirect cascade reads
  // as a flash/reload). Show an inline message with a manual way back instead.
  if (error) {
    return (
      <Flex width="full" minHeight="60vh" align="center" justify="center" p={8}>
        <VStack spacing={4} maxWidth="420px" textAlign="center">
          <Text fontSize="lg" fontWeight={600}>This watch couldn't be loaded</Text>
          <Text fontSize="sm" color="gray.500">
            You may not have access, or it may have been removed.
          </Text>
          <Button as={Link} to="/projects" size="sm" colorScheme="blue">
            Back to watches
          </Button>
        </VStack>
      </Flex>
    );
  }

  // Genuinely not found (no data, no error) → go to the watches list.
  return <Navigate to="/projects" replace />;
};
